<template>
  <resource-collection>
    <template slot-scope="{item}">
      <user :user="item"/>
    </template>
  </resource-collection>
</template>

<script>
import User from './User.vue';
import collection from '../../mixins/collection';
import ResourceCollection from '../resources/ResourceCollection.vue';

export default {
  mixins: [collection],

  components: { User, ResourceCollection },

  mounted() {
    Event.listen('userUpdated', user => this.update(user));
    Event.listen('userCreated', user => this.prepend(user));
    Event.listen('userDeleted', user => this.remove(user));
  },
};
</script>